import React, { useState } from 'react';
import { FaArrowUp } from 'react-icons/fa';
import { useLenis } from '../SmoothScroll/SmoothScroll';
import './BackToTop.css';

function BackToTop() {
  const [visible, setVisible] = useState(false);

  const lenis = useLenis((instance) => {
    setVisible(instance.scroll > 300);
  });

  const scrollToTop = () => {
    if (!lenis) return;
    lenis.scrollTo(0, {
      duration: 1.4,
      easing: (t) => 1 - Math.pow(1 - t, 4),
    });
  };

  if (!visible) return null;

  return (
    <div className="backToTop">
      <button
        onClick={scrollToTop}
        aria-label="Back to top"
        className="back-top-btn"
      >
        <FaArrowUp />
      </button>
    </div>
  );
}

export default BackToTop;
